import { gql } from '@apollo/client';

export const FRAGMENT_ROLE_HIERARCHY_DATA = gql`
  fragment RoleHierarchyDataFields on RoleHierarchy {
    role {
      id
      name
    }
    sequence
    level
  }
  fragment RoleHierarchyData on ProjectCategory {
    roleHierarchy {
      department {
        ...RoleHierarchyDataFields
      }
      faculty {
        ...RoleHierarchyDataFields
      }
      school {
        ...RoleHierarchyDataFields
      }
      NAU {
        ...RoleHierarchyDataFields
      }
    }
  }
`;

export const GET_PROJECT_CATEGORIES = gql`
  query GET_PROJECT_CATEGORIES($ids: [ID!], $state: State) {
    projectCategories(ids: $ids, state: $state) {
      id
      name
      workProgrammeFrom
      workProgrammeTo
      virementThreshold
      disabled
      seq
    }
  }
`;

export const ADD_PROJECT_CATEGORY = gql`
  mutation ADD_PROJECT_CATEGORY(
    $addProjectCategoryInput: AddProjectCategoryInput!
  ) {
    addProjectCategory(input: $addProjectCategoryInput) {
      id
      name
      workProgrammeFrom
      workProgrammeTo
      disabled
      seq
    }
  }
`;

export const UPDATE_PROJECT_CATEGORY = gql`
  mutation UPDATE_PROJECT_CATEGORY(
    $updateProjectCategoryInput: UpdateProjectCategoryInput!
  ) {
    updateProjectCategory(input: $updateProjectCategoryInput) {
      id
      name
      workProgrammeFrom
      workProgrammeTo
      disabled
      seq
    }
  }
`;

export const COPY_PROJECT_CATEGORY = gql`
  mutation COPY_PROJECT_CATEGORY(
    $copyProjectCategoryInput: CopyProjectCategoryInput!
  ) {
    copyProjectCategory(input: $copyProjectCategoryInput) {
      id
      name
      workProgrammeFrom
      workProgrammeTo
      disabled
      seq
    }
  }
`;

export const TOGGLE_DISABLED_PROJECT_CATEGORY = gql`
  mutation TOGGLE_DISABLED_PROJECT_CATEGORY($id: ID!) {
    toggleDisabledProjectCategory(id: $id) {
      id
      name
      workProgrammeFrom
      workProgrammeTo
      disabled
      seq
    }
  }
`;

export const UPDATE_ROLE_HIERARCHY = gql`
  ${FRAGMENT_ROLE_HIERARCHY_DATA}
  mutation UPDATE_ROLE_HIERARCHY(
    $updateRoleHierarchyInput: UpdateRoleHierarchyInput!
  ) {
    updateRoleHierarchy(input: $updateRoleHierarchyInput) {
      id
      name
      ...RoleHierarchyData
    }
  }
`;

export const GET_ROLE_HIERARCHY = gql`
  ${FRAGMENT_ROLE_HIERARCHY_DATA}
  query GET_ROLE_HIERARCHY($ids: [ID!], $state: State) {
    projectCategories(ids: $ids, state: $state) {
      id
      ...RoleHierarchyData
    }
  }
`;

export const GET_REPRORT_SETTINGS = gql`
  query GET_REPRORT_SETTINGS($ids: [ID!], $state: State) {
    projectCategories(ids: $ids, state: $state) {
      id
      reportSettings {
        reportType
        reportForm
      }
    }
  }
`;

export const UPDATE_REPRORT_SETTINGS = gql`
  mutation UPDATE_REPRORT_SETTINGS(
    $updateReportSettingsInput: UpdateReportSettingsInput!
  ) {
    updateReportSettings(input: $updateReportSettingsInput) {
      id
      name
      reportSettings {
        reportType
        reportForm
      }
    }
  }
`;

export const GET_OVERRIDDEN_SCOPES_BY_ROLE = gql`
  query GET_OVERRIDDEN_SCOPES_BY_ROLE($ids: [ID!], $state: State) {
    projectCategories(ids: $ids, state: $state) {
      id
      overriddenScopesByRoleInProjectCategory {
        id
        role {
          id
          name
        }
        scopes {
          type
          level
        }
      }
    }
  }
`;

export const DELETE_OVERRIDDEN_SCOPES_BY_ROLE = gql`
  mutation DELETE_OVERRIDDEN_SCOPES_BY_ROLE(
    $input: DeleteOverriddenScopesByRoleInProjectCategoryInput!
  ) {
    deleteOverriddenScopesByRoleInProjectCategory(input: $input)
  }
`;

export const ADD_OVERRIDDEN_SCOPES_BY_ROLE = gql`
  mutation ADD_OVERRIDDEN_SCOPES_BY_ROLE(
    $input: AddOverriddenScopesByRoleInProjectCategoryInput!
  ) {
    addOverriddenScopesByRoleInProjectCategory(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_OVERRIDDEN_SCOPES_BY_ROLE = gql`
  mutation UPDATE_OVERRIDDEN_SCOPES_BY_ROLE(
    $input: UpdateOverriddenScopesByRoleInProjectCategoryInput!
  ) {
    updateOverriddenScopesByRoleInProjectCategory(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES = gql`
  mutation UPDATE_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES(
    $input: UpdateProjectCategoryApprovalRouteTemplatesInput!
  ) {
    updateProjectCategoryApprovalRouteTemplates(input: $input) {
      id
      name
    }
  }
`;

export const GET_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES = gql`
  query GET_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES(
    $ids: [ID!]
    $state: State
  ) {
    projectCategories(ids: $ids, state: $state) {
      id
      approvalRouteTemplates {
        virement {
          id
          name
        }
        proposalRevision {
          id
          name
        }
        extension {
          id
          name
        }
        extensionBeyondDeadlineOfUsingUpFunding {
          id
          name
        }
        withdrawal {
          id
          name
        }
      }
    }
  }
`;
